/* eslint-disable camelcase */
import { type UseQueryResult, useQuery } from 'react-query';
import {
  TransferAllocateService,
  Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDashboardDto,
} from '../../services/wealthlane-award-services';
import { TableParams } from '../../types/common';

const useGetDrsRegistrationDashboard = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams
): UseQueryResult<
  Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDashboardDto[] | undefined,
  unknown
> => {
  const { companyId, transferStatusIds, containerStatusIds, _force } = tableInfo;
  const drsRegistrationDashboard = useQuery(
    ['useGetDrsRegistrationDashboard', companyId, transferStatusIds, containerStatusIds, _force],
    async () => {
      return await handleRequest(
        TransferAllocateService.getApiAwardApiAppTransferAllocateTransferAllocateDashboardForDrs(
          [transferStatusIds],
          [containerStatusIds],
          companyId
        )
      );
    }
  );

  return drsRegistrationDashboard;
};

export default useGetDrsRegistrationDashboard;
